import * as Yup from "yup"

import type { AppLocalization } from "../../../modules/localization/appLocalization"

import type { MonetaryRange } from "./numericFieldTypes"

type L10n = Pick<AppLocalization, "getString">

export function monetaryFieldSchema(
    range: MonetaryRange,
    l10n: L10n,
    label: string,
): Yup.NumberSchema<number | null | undefined> {
    const schema = Yup.number().nullable().typeError(l10n.getString("numeric-field-invalid-error", { label }))

    switch (range) {
        case "positive":
            return schema.positive(l10n.getString("numeric-field-positive-error", { label }))
        case "non-negative":
            return schema.min(0, l10n.getString("numeric-field-non-negative-error", { label }))
        case "negative":
            return schema.negative(l10n.getString("numeric-field-negative-error", { label }))
        case "non-positive":
            return schema.max(0, l10n.getString("numeric-field-non-positive-error", { label }))
        case "all":
            return schema
    }
}
